module.exports = "<div class=\"footer\">\r\n  <div class=\"copyright\">&copy; 2020 AEMO</div>\r\n  <div class=\"footer-space-fill\"></div>\r\n  <div class=\"contact\"></div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/views/footer.html
// module id = 437
// module chunks = 0